'use strict';

var placesStorage = require('./places_storage');

var apiUrl = [Groupon.endpoints.my_places, 'v1'].join('/');
var myPlaceDataCookieKey = 'my_place_data';

function callApi(options, _ref) {
  var _success = _ref.success,
      _error = _ref.error;

  placesStorage.fetching = true;
  return $.ajax(Object.assign({
    url: apiUrl,
    headers: { 'x-ls-client-req': true, 'x-ls-locale': I18n.locale },
    success: function success(res) {
      placesStorage.fetchSuccess(res.data);
      if (_success) {
        _success(res);
      }
    },
    error: function error(err) {
      placesStorage.fetchError(err);
      if (_error) {
        _error(err);
      }
    }
  }, options));
}

module.exports = {

  // load all my places
  fetch: function fetch(_ref2) {
    var success = _ref2.success,
        error = _ref2.error;

    callApi({ type: 'GET' }, { success: success, error: error });
  },

  // remove one my place
  // load all my places after it removed successfuly
  remove: function remove(id, _ref3) {
    var success = _ref3.success,
        error = _ref3.error;

    callApi({
      type: 'DELETE',
      url: apiUrl + '?placeId=' + id
    }, { success: success, error: error });
  },

  // create a new my place
  // load all my places after it added successfuly
  save: function save(data, _ref4) {
    var success = _ref4.success,
        error = _ref4.error;

    callApi({
      type: 'POST',
      url: '' + apiUrl,
      data: data
    }, { success: success, error: error });
  },

  // get icon class by type
  getIcon: placesStorage.getIcon,

  // check if use has been signed in
  isLoggedIn: function isLoggedIn() {
    try {
      return !!window.sessionStorage.getItem('verifiedUser');
    } catch (e) {
      return false;
    }
  },
  setCookie: function setCookie(name, val) {
    Cookie.set(name, val);
  },
  getCookie: function getCookie(name) {
    var val = Cookie.get(name);
    if (val) {
      return val.replace(/\+/g, ' '); // Cookie.set will replace space to plus
    }
    return val;
  },
  removeCookie: function removeCookie(name) {
    Cookie.unset(name, '.groupon.com');
    Cookie.unset(name);
  },


  // validate place data
  validatePlace: function validatePlace(place) {
    return place && place.type && place.icon && place.address;
  },


  // translate the my place type
  translateType: function translateType(type) {
    var translations = Groupon.LS.translations.search || {};
    if (type === 'work') {
      return translations.myPlaceTypeWork || 'Work';
    }
    if (type === 'play') {
      return translations.myPlaceTypeFavorite || 'Favorite';
    }
    return translations.myPlaceTypeHome || 'Home';
  },


  // Save the my place data to Cookie before redirects to login page
  saveMyPlaceToCookie: function saveMyPlaceToCookie(place) {
    if (this.validatePlace(place)) {
      var type = place.type,
          icon = place.icon,
          address = place.address;

      this.setCookie(myPlaceDataCookieKey, JSON.stringify({
        type: this.translateType(type), // the translated type
        name: type, // the original type
        icon: icon,
        address: address
      }));
    }
  },


  // remove the my place data from cookie
  removeMyPlaceFromCookie: function removeMyPlaceFromCookie() {
    this.removeCookie(myPlaceDataCookieKey);
  },


  // load saved place from cookie
  loadMyPlaceFromCookie: function loadMyPlaceFromCookie() {
    var placeStr = Cookie.get(myPlaceDataCookieKey);
    if (placeStr) {
      try {
        var place = JSON.parse(placeStr); // parse string to object
        if (this.validatePlace(place)) {
          // check properties
          place.type = place.name; // get the original type
          return place;
        }
      } catch (ex) {
        // if it's an invalid cookie value, delete it!
        this.removeCookie(myPlaceDataCookieKey);
      }
    }
    return null;
  },


  // save the place
  savePlace: function savePlace(place, _ref5) {
    var success = _ref5.success,
        error = _ref5.error;
    var type = place.type,
        address = place.address;


    if (!this.isLoggedIn()) {
      // not signed in
      this.saveMyPlaceToCookie(place);
      var signInUrl = '/login?return_to=' + encodeURIComponent(window.location.href);
      window.location.href = signInUrl;
    } else {
      // signed in
      // call API to save it
      this.save({ type: type, address: address }, {
        success: success,
        error: error
      });
    }
  }
};